// extracted by mini-css-extract-plugin
export default {"header":"header---tK949","headerText":"headerText---FZzPo"};